import React, {useState, useEffect} from "react";
import {useSelector, useDispatch} from "react-redux";
import useOnClickOutside from "use-onclickoutside";
import XMLViewer from "react-xml-viewer";

import * as actionTypes from "../../../store/actions/actionTypes";
import Admission_ModalInfo from "../../Block/Admission_ModalInfo";
import {useToasts} from "react-toast-notifications";

const xmlTheme = {overflowBreak:true};

const PreviewXml = () => {
    const {show, admission, xml} = useSelector(state => state.modal.fydo_previewXml);
    const ref = React.useRef(null);
    const dispatch = useDispatch();
    const {addToast} = useToasts();

    const hideModal = () => dispatch({type: actionTypes.MODAL_ADMISSION_FYDO_PREVIEW_XML_HIDE});
    useOnClickOutside(ref, () => hideModal());

    const renderModal = () => {
        if (show) {
            return (
                <div className="modal-dialog modal-content-large" role="document" ref={ref} autoFocus={false}>
                    <div className="modal-content modal-content-fit">
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                                onClick={hideModal}>
                            <span aria-hidden="true">×</span>
                        </button>
                        <div className="modal-body">
                            <h3>FYDO Xml for for {admission.title} {admission.surname}, {admission.name}</h3>
                            <Admission_ModalInfo admission={admission} showMobileInfo={false} />
                            <form className="person-info-form">
                                <XMLViewer xml={xml} theme={xmlTheme}/>
                            </form>
                        </div>
                    </div>
                </div>
            );
        }
        return null;
    }

    return (
        <>
            <div className={`modal fade ${show ? 'show' : ''}`} id="personModal" tabIndex="-1" role="dialog"
                 aria-labelledby="personModalLabel" aria-modal="true">
                {renderModal()}
            </div>
        </>
    );
}

export default PreviewXml;